import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RequestBodyConverter } from '../RequestBodyConverter';
import { useParams } from 'react-router-dom';
import SpecialOfferForm from './SpecialOfferForm';
// import { initialValues  } from './initialValues-testing';
import { showSpecialOfferApi, updateSpecialOfferApi, clearEditedSpecialOffer } from './specialOfferSlice';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { PICTURE_ATTRIBUTE_NAMES } from '~/config/constants';

function SpecialOfferUpdate() {
    const { id } = useParams();
    const [resetCount, setResetCount] = useState(0);
    const { editedModel: initialValues } = useSelector((state) => state.shopSaga.specialOffer);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (rawValues) => {
        let values = new RequestBodyConverter(rawValues);
        values = values.data;
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.
        dispatch(updateSpecialOfferApi({ navigate, values, id }));
    };

    useEffect(() => {
        dispatch(showSpecialOfferApi({ navigate, id }));

        return () => dispatch(clearEditedSpecialOffer());
    }, []);

    return (
        <SpecialOfferForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={PICTURE_ATTRIBUTE_NAMES}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default SpecialOfferUpdate;
